import { getRgObjectsOfType as o } from "@project-rouge/rg-core";
import { getRgObjectsAtLevel as r } from "../../utils/rg-util/index3.js";
function i(t, e, g) {
  return g === void 0 ? o(t, e).length : r(t, e, g).length;
}
export {
  i as getCountOfType
};
//# sourceMappingURL=index.js.map
